import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  fixedAssetBulkUploadApi,
  addFixedAssetApi,
  deleteFixedAssetApi,
  getFinacAssetIdApi,
  getFixedAssetHistoryApi,
  getFixedAssetRegisterListingApi,
  getSingleFinacAssetApi,
  postFixedAssetVerification,
  updateFixedAssetApi,
  getAuditSessionListApi,
  createAuditSessionApi,
  updateAuditSessionApi,
  getFARUsersHistory,
} from "@/apis/fixedAssetRegisterApi";

import type {
  AddAuditSessionPayloadType,
  FixedAssetAddUpdateType,
  FixedAssetGetFinacAssetType,
  FixedAssetHistoryPayloadType,
  FixedAssetSingleType,
  FixedAssetVerificationType,
  GetAuditSessionPayloadType,
  GetFARUsersHistoryPayloadType,
  UpdateAuditSessionPayloadType,
} from "@/commonTypes/fixedAssetRegisterTypes";

export const addNewFixedAsset = createAsyncThunk(
  `addNewFixedAsset`,
  async (data: FixedAssetAddUpdateType) => {
    const response = await addFixedAssetApi(data);
    return response.data;
  }
);

export const getFixedAssetId = createAsyncThunk(
  `getFixedAssetId`,
  async (data: FixedAssetGetFinacAssetType) => {
    const response = await getFinacAssetIdApi(data);
    return response.data;
  }
);
export const getFixedAssetRegisterListing = createAsyncThunk(
  `getFixedAssetRegisterListing`,
  async (data: any) => {
    const response = await getFixedAssetRegisterListingApi(data);
    return response.data;
  }
);

export const getSingleFixedAsset = createAsyncThunk(
  `getSingleFixedAsset`,
  async (data: FixedAssetSingleType) => {
    const response = await getSingleFinacAssetApi(data);
    return response.data;
  }
);

export const updateFixedAsset = createAsyncThunk(
  `updateFixedAsset`,
  async (data: any) => {
    const response = await updateFixedAssetApi(data);
    return response.data;
  }
);

export const deleteFixedAssetRegisterAction = createAsyncThunk(
  `deleteFixedAsset`,
  async (data: any) => {
    const response = await deleteFixedAssetApi(data);
    return response.data;
  }
);
export const fixedAssetBulkUploadDataAction = createAsyncThunk(
  `bulkUploadFixedAsset`,
  async (data: any) => {
    const response = await fixedAssetBulkUploadApi(data);
    return response.data;
  }
);

export const postFixedAssetVerificationAction = createAsyncThunk(
  `fixedAssetVerfication`,
  async (data: FixedAssetVerificationType) => {
    const response = await postFixedAssetVerification(data);
    return response.data;
  }
);
export const getFixedAssetHistoryAction = createAsyncThunk(
  `fixedAssetVerfication/history`,
  async (data: FixedAssetHistoryPayloadType) => {
    const response = await getFixedAssetHistoryApi(data);
    return response.data;
  }
);

export const getAuditSessionAction = createAsyncThunk(
  "get/auditSession",
  async (data: GetAuditSessionPayloadType) => {
    const response = await getAuditSessionListApi(data);

    return response.data;
  }
);

export const createAuditSessionAction = createAsyncThunk(
  "add/auditSession",
  async (data: AddAuditSessionPayloadType) => {
    const response = await createAuditSessionApi(data);
    return response.data;
  }
);

export const updateAuditSessionAction = createAsyncThunk(
  `update/auditSession`,
  async (data: UpdateAuditSessionPayloadType) => {
    const response = await updateAuditSessionApi(data);
    return response.data;
  }
);

export const getFARUsersHistoryAction = createAsyncThunk(
  `history/fixedAssetUsers`,
  async (data: GetFARUsersHistoryPayloadType) => {
    const response = await getFARUsersHistory(data);
    return response.data;
  }
);
